<div class="tab-content">
  <mat-form-field appearance="outline" class="wsz-field">
    <mat-label>WSZ</mat-label>
    <mat-select [(ngModel)]="selectedWsz" (selectionChange)="onWszChange()" [disabled]="loadingWsz">
      <mat-option *ngIf="!loadingWsz && !wszOptions.length" disabled>Nessuna WSZ disponibile</mat-option>
      <mat-option *ngFor="let wsz of wszOptions" [value]="wsz">{{ wsz }}</mat-option>
    </mat-select>
  </mat-form-field>
</div>

<mat-progress-bar mode="indeterminate" *ngIf="loadingRows"></mat-progress-bar>

<div class="empty-state mt-4" *ngIf="!selectedWsz">
  <mat-icon class="empty-state-icon">filter_alt</mat-icon>
  <span>Seleziona una WSZ per vedere {{ tipo === 'prelievi' ? 'i prelievi' : 'i superamenti' }} da trasmettere</span>
</div>

<div class="table-wrapper mt-2" *ngIf="rows.length">
  <table mat-table [dataSource]="rows" class="w-100">
    <ng-container matColumnDef="selected">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox [(ngModel)]="row.selected"></mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="idPuntoCampionamento">
      <th mat-header-cell *matHeaderCellDef>Punto di campionamento</th>
      <td mat-cell *matCellDef="let row">{{ row.idPuntoCampionamento }}</td>
    </ng-container>

    <ng-container matColumnDef="dataOraPrelievo">
      <th mat-header-cell *matHeaderCellDef>Data prelievo</th>
      <td mat-cell *matCellDef="let row">{{ row.dataOraPrelievo | date: 'dd/MM/yyyy HH:mm' }}</td>
    </ng-container>

    <ng-container matColumnDef="codicePrelievo">
      <th mat-header-cell *matHeaderCellDef>Codice prelievo</th>
      <td mat-cell *matCellDef="let row">{{ row.codicePrelievo }}</td>
    </ng-container>

    <ng-container matColumnDef="codiceParametro">
      <th mat-header-cell *matHeaderCellDef>Parametro</th>
      <td mat-cell *matCellDef="let row">{{ row.codiceParametro }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>
  </table>
</div>

<div *ngIf="selectedWsz && !loadingRows && !rows.length" class="mt-2">
  Nessun {{ tipo === 'prelievi' ? 'prelievo' : 'superamento' }} da trasmettere per questa WSZ.
</div>

<div class="d-flex align-items-center justify-content-between mt-2" *ngIf="rows.length">
  <span>{{ selectedCount }} / {{ rows.length }} selezionati</span>
  <button mat-raised-button color="primary" [disabled]="!selectedCount || trasmitting" (click)="trasmetti()">
    <mat-icon>send</mat-icon>
    Trasmetti
  </button>
</div>

<div class="mt-2" *ngIf="tipo === 'prelievi' && elaborazione">
  Stato elaborazione: <strong>{{ statoLabel }}</strong>
  <span *ngIf="erroreLabel"> — {{ erroreLabel }}</span>
</div>

<div class="mt-2" *ngIf="tipo === 'superamenti' && risultatiSuperamenti.length">
  <div *ngFor="let esito of risultatiSuperamenti">
    <ng-container *ngIf="datiRiga(esito.id) as riga">
      <mat-icon *ngIf="esito.successo" class="esito-icon-successo">check_circle</mat-icon>
      <mat-icon *ngIf="!esito.successo" class="esito-icon-errore">error</mat-icon>
      {{ riga.codiceParametro }} ({{ riga.dataOraPrelievo | date: 'dd/MM/yyyy' }}): {{ esito.successo ? 'trasmesso con successo' : esito.messaggio }}
    </ng-container>
  </div>
</div>
